import { render, staticRenderFns } from "./BeteiligteItem.vue?vue&type=template&id=86c51618&scoped=true&"
import script from "./BeteiligteItem.vue?vue&type=script&lang=js&"
export * from "./BeteiligteItem.vue?vue&type=script&lang=js&"
import style0 from "./BeteiligteItem.vue?vue&type=style&index=0&id=86c51618&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c51618",
  null
  
)

export default component.exports